import styled from "styled-components";

export const CommitmentQuestionAligner = styled.div`
  margin: 20px auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  @media (max-width: 910px) {
    margin: 20px auto;
    width: 85%;
  }
`;
export const CommitmentQuestionTitle = styled.p`
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #808080;
`;
export const CommitmentQuestionContainer = styled.div`
  padding: 15px 15px 7px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  border: 2px dashed #808080;
`;
export const NoAssignedQuestionsText = styled.p`
  margin-bottom: 8px;
  height: 54px;
  font-size: 18px;
  font-weight: bold;
  color: #808080;
  display: flex;
  align-items: center;
`;
